import type { FieldValues, Path } from 'react-hook-form';
import { useFormContext } from 'react-hook-form';

export const useSetDirtyValue = <
  TFieldValues extends FieldValues = FieldValues,
>() => {
  const { setValue } = useFormContext<TFieldValues>();
  return (name: Path<TFieldValues>, value: unknown) => {
    setValue(name, value as TFieldValues[keyof TFieldValues], {
      shouldDirty: true,
      shouldTouch: false,
      shouldValidate: false,
    });
  };
};

export default useSetDirtyValue;
